import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home.component';
import { NgModule } from '@angular/core';

export const HOME_PATH = 'home';

const routes: Routes = [
  {
    path: HOME_PATH,
    component: HomeComponent,
    children: [
      {
        path: 'explore',
        loadChildren: () => import('./pages/explore-page/explore-page.module').then((m) => m.ExplorePageModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages/profile-page/profile-page.module').then((m) => m.ProfilePageModule),
      },
      {
        path: 'activity',
        loadChildren: () => import('./pages/activity-page/activity-page.module').then((m) => m.ActivityPageModule),
      },
      {
        path: 'group',
        loadChildren: () => import('./pages/group-page/group-page.module').then((m) => m.GroupPageModule),
      },
      {
        path: 'message',
        loadChildren: () => import('./pages/message-page/messaging-page.module').then((m) => m.MessagingPageModule),
      },
      {
        path: 'rate-outing',
        loadChildren: () =>
          import('./pages/outing-rating/rate-outing-page/rate-outing.module').then((m) => m.RateOutingPageModule),
      },
      {
        path: 'mark-participants',
        loadChildren: () =>
          import('./pages/outing-rating/mark-participants-page/mark-participants.module').then(
            (m) => m.MarkParticipantsPageModule,
          ),
      },
      {
        path: 'create-event',
        loadChildren: () =>
          import('./pages/create-event-page/create-event-page.module').then((m) => m.CreateEventPageModule),
      },
      {
        path: 'pending-requests/:id',
        loadChildren: () =>
          import('./pages/pending-requests-to-join-group-page/pending-requests-to-join-group-page.routing'),
      },
      {
        path: 'edit-group/:id',
        loadChildren: () => import('./pages/edit-group-page/edit-group-page.module').then((m) => m.EditGroupPageModule),
      },
      {
        path: 'edit-group-details',
        loadChildren: () => import('./pages/edit-group-details-page/edit-group-details-page.routing'),
      },
      {
        path: 'create-group',
        loadChildren: () =>
          import('./pages/create-group-page/create-group-page.module').then((m) => m.CreateGroupPageModule),
      },
      {
        path: 'delete-group',
        loadChildren: () => import('./pages/delete-group-page/delete-group-page.routing'),
      },
      {
        path: 'unable-to-delete-group',
        loadChildren: () =>
          import('./pages/unable-to-delete-group-page/unable-to-delete-group-page.module').then(
            (m) => m.UnableToDeleteGroupPageModule,
          ),
      },
      {
        path: 'delete-sport',
        loadChildren: () => import('./pages/delete-sport-page/delete-sport-page.routing'),
      },
      {
        path: 'detail-activity/:id/payment/register',
        loadChildren: () =>
          import('./pages/activity-detail-page/pages/pay-to-register-page/pay-to-register-page.module').then(
            (m) => m.PayToRegisterPageModule,
          ),
      },
      // Promo code page disabled until the backend can validate/apply a code
      // (process-deposit ignores promoCodeId today). Re-enable with the promo UI
      // flag in pay-to-register. Ticket 1219031258438832.
      // {
      //   path: 'detail-activity/:id/payment/promo-code',
      //   loadChildren: () =>
      //     import('./pages/activity-detail-page/pages/promo-code-page/promo-code-page.module').then(
      //       (m) => m.PromoCodePageModule,
      //     ),
      // },
      {
        path: 'detail-activity/:id/payment/method',
        loadChildren: () =>
          import('./pages/profile-page/pages/payment-method-page/payment-method-page.module').then(
            (m) => m.PaymentMethodPageModule,
          ),
      },
      {
        path: 'detail-activity/:id/share-with-groups',
        loadChildren: () =>
          import('./pages/share-with-groups-page/share-with-groups-page.module').then(
            (m) => m.ShareWithGroupsPageModule,
          ),
      },
      {
        path: 'detail-activity/:id',
        loadChildren: () =>
          import('./pages/activity-detail-page/activity-detail-page.module').then((m) => m.ActivityDetailPageModule),
      },
      {
        path: 'edit-activity/:id',
        loadChildren: () =>
          import('./pages/edit-activity-page/edit-activity-page.module').then((m) => m.EditActivityPageModule),
      },
      {
        path: 'member/:userId',
        loadComponent: () => import('./pages/member-page/member-page.component').then((m) => m.MemberPageComponent),
      },
      // The two lists of a member, one component and a direction. French in
      // the URL like the rest of the application, and the direction in the
      // route rather than in a query string, so the back arrow works.
      {
        path: 'member/:userId/abonnements',
        data: { direction: 'following' },
        loadComponent: () =>
          import('./pages/follow-list-page/follow-list-page.component').then((m) => m.FollowListPageComponent),
      },
      {
        path: 'member/:userId/abonnes',
        data: { direction: 'followers' },
        loadComponent: () =>
          import('./pages/follow-list-page/follow-list-page.component').then((m) => m.FollowListPageComponent),
      },
      {
        // « Après la sortie », opened by the push of the morning after an outing.
        path: 'apres-sortie/:id',
        loadComponent: () =>
          import('./pages/after-outing-page/after-outing-page.component').then((m) => m.AfterOutingPageComponent),
      },
      {
        // « Refaire », from a past outing in « Mes activités » or on its page.
        path: 'refaire/:id',
        loadComponent: () =>
          import('./pages/do-it-again-page/do-it-again-page.component').then((m) => m.DoItAgainPageComponent),
      },
      {
        path: 'search',
        loadChildren: () => import('./pages/search-page/search-page.module').then((m) => m.SearchPageModule),
      },
      {
        path: 'all-invitations',
        loadChildren: () =>
          import('./pages/all-invitations-page/all-invitations-page.module').then((m) => m.AllInvitationsPageModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./pages/notifications-page/notifications-page.module').then((m) => m.NotificationsPageModule),
      },
      {
        path: '',
        redirectTo: '/home/explore',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: '/home/explore',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class HomeRoutingModule {}
